module.exports = __webpack_public_path__ + "static/rohit-tandon-105772-unsplash-c7dc4808e4ff9cc291df1892566d2c61.jpg";